import { api } from "../../api";

export * from "./spBookings";
export * from "./spAvailability";

export const spApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSpProfile: build.query({
            query: () => `/v1/service-provider/`,
        }),
        getSpProfileFieldType: build.query({
            query: () => `/v1/service-provider/profile-field-type`,
        }),
        updateSpProfile: build.mutation({
            query: (data) => {
                // Backend expects PUT /v1/service-provider/update/{id}
                // with multipart/form-data.
                return {
                    url: `/v1/service-provider/update/${data.id}`,
                    method: "PUT",
                    body: data.body,
                };
            },
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetSpProfileQuery,
    useGetSpProfileFieldTypeQuery,
    useUpdateSpProfileMutation,
} = spApi;
